// custom-cursor.js

// Hulpvariabelen in de module-scope, zodat zowel init als destroy erbij kunnen
let eventRemovers = [];
let animationFrameId = null;

/**
 * Initialiseer de custom cursor op basis van jouw code.
 * @param {HTMLElement} [root=document] Optioneel, container waarin je cursor-classes staan.
 */

export function initCursor(root = document) {
    
    // Reset arrays en IDs elke keer dat je init aanroept
    eventRemovers = [];
    animationFrameId = null;

    // Helper om eventlisteners toe te voegen + te onthouden
    function addListener(el, evt, handler, opts) {
        el.addEventListener(evt, handler, opts);
        eventRemovers.push(() => el.removeEventListener(evt, handler, opts));
    }

  // Custom Cursor
  var cursor = {
    delay: 8,
    _x: 0,
    _y: 0,
    endX: (window.innerWidth / 2),
    endY: (window.innerHeight / 2),
    cursorVisible: true,
    cursorEnlarged: false,
    $dot: document.querySelector('.cursor-dot'),
    $outline: document.querySelector('.cursor-outline'),
    $text: document.createElement('span'),
    
    init: function() {
        if (!this.$dot || !this.$outline) {
            console.error('Cursor not found');
            return; 
        }

        //this.$outline.appendChild(this.$text);
        //this.$text.classList.add('cursor-text'); 
        //this.$dot.appendChild(this.$text);

        // Check of er al een cursor-text bestaat en verwijder die
        const existingText = this.$dot.querySelector('.cursor-text');
        if (existingText) existingText.remove();

        // Voeg de nieuwe cursor-text toe
        this.$text.classList.add('cursor-text'); 
        this.$dot.appendChild(this.$text);

        // Set up element sizes
        this.dotSize = this.$dot.offsetWidth;
        this.outlineSize = this.$outline.offsetWidth;
        
        this.setupEventListeners();
        this.animateDotOutline();
    },
    
    setupEventListeners: function() {
        var self = this;
        
        // Footer hover
        const footer = root.querySelector('footer');
        if (footer) {
            addListener(footer, 'mouseover', () => {
            self.$dot.style.backgroundColor = 'black';
            self.$outline.style.borderColor = 'black';
            });
            addListener(footer, 'mouseout', () => {
            self.$dot.style.backgroundColor = '';
            self.$outline.style.borderColor = '';
            });
        }

        // Anchor hovering
        //document.querySelectorAll('a').forEach(function(el) {
        root.querySelectorAll(`
            a, button, [role="button"], [type="button"], 
            [type="submit"], [type="reset"], input, textarea, select, 
            label, [tabindex="0"], [contenteditable], summary
            `).forEach(function(el) {
            addListener(el, 'mouseover', () => {
                self.cursorEnlarged = true;
                self.toggleCursorSize();
            });
            addListener(el, 'mouseout', () => {
                self.cursorEnlarged = false;
                self.toggleCursorSize();
            });
        });
        
        // Menu items
        root.querySelectorAll('.menu-item a').forEach(function(el) {
            addListener(el, 'mouseover', () => {
              self.$outline.style.opacity = 0; // Verberg de outline
            });
            addListener(el, 'mouseout', () => {
              self.$outline.style.opacity = 1; // Toon de outline
            });
        });

        // Projects
        root.querySelectorAll('.card__project a').forEach(function(el) {
            addListener(el, 'mouseover', (event) => {
              if (!event.target.closest('figure')) return;
              self.$text.innerHTML = '<span>Bekijk</span><span>project</span>';
              self.$dot.style.transform = 'translate(-50%, -50%) scale(3) rotate(-10deg)';
              self.$dot.classList.add('hover-active');
              self.$outline.style.visibility = 'hidden';
            });
            addListener(el, 'mouseout', (event) => {
              if (!event.target.closest('figure')) return;
              self.$text.innerHTML = '';
              self.$dot.style.transform = 'translate(-50%, -50%) scale(1) rotate(0deg)';
              self.$dot.classList.remove('hover-active');
              self.$outline.style.visibility = 'visible';
            });
        });
        
        // Click events
        addListener(document, 'mousedown', () => {
            self.cursorEnlarged = true;
            self.toggleCursorSize();
        });
        addListener(document, 'mouseup', () => {
            self.cursorEnlarged = false;
            self.toggleCursorSize();
        });
        
        // Mouse move
        addListener(document, 'mousemove', (e) => {
            self.cursorVisible = true;
            self.toggleCursorVisibility();
    
            self.endX = e.pageX;
            self.endY = e.pageY;
            self.$dot.style.top = self.endY + 'px';
            self.$dot.style.left = self.endX + 'px';
        });
        
        // Hide/show cursor
        addListener(document, 'mouseenter', () => {
            self.cursorVisible = true;
            self.toggleCursorVisibility();
            self.$dot.style.opacity = 1;
            self.$outline.style.opacity = 1;
        });
        
        addListener(document, 'mouseleave', () => {
            self.cursorVisible = false;
            self.toggleCursorVisibility();
            self.$dot.style.opacity = 0;
            self.$outline.style.opacity = 0;
        });

    },
    
    // De trailing effect-animatie
    animateDotOutline() {
        const self = this;
  
        function loop() {
          self._x += (self.endX - self._x) / self.delay;
          self._y += (self.endY - self._y) / self.delay;

          self.$outline.style.top = self._y + 'px';
          self.$outline.style.left = self._x + 'px';
  
          animationFrameId = requestAnimationFrame(loop);
        }
  
        loop();
   },
    
    toggleCursorSize: function() {
        var self = this;
        
        if (self.cursorEnlarged) {
            self.$dot.style.transform = 'translate(-50%, -50%) scale(0.75)';
            self.$outline.style.transform = 'translate(-50%, -50%) scale(1.5)';
            self.$outline.classList.add('cursor-outline--large');
        } else {
            self.$dot.style.transform = 'translate(-50%, -50%) scale(1)';
            self.$outline.style.transform = 'translate(-50%, -50%) scale(1)';
            self.$outline.classList.remove('cursor-outline--large');
        }
    },
    
    toggleCursorVisibility: function() {
        var self = this;
        
        if (self.cursorVisible) {
            self.$dot.style.opacity = 1;
            self.$outline.style.opacity = 1;
        } else {
            self.$dot.style.opacity = 0;
            self.$outline.style.opacity = 0;
        }
    }
    
  }

  cursor.init();

}

/**
 * Vernietig alle cursor-luisteraars en animaties
 */
export function destroyCursor() {

    //console.log('⚠️ destroyCursor() called!');

    // 1. Verwijder alle event listeners
    eventRemovers.forEach(removeFn => removeFn());
    eventRemovers = [];
  
    // 2. Annuleer de requestAnimationFrame-lus
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }

    // 3. Verwijder de cursor-tekst als die nog bestaat
    const dotEl = document.querySelector('.cursor-dot');
    if (dotEl) {
        const textEl = dotEl.querySelector('.cursor-text');
        if (textEl) textEl.remove();
    }

}
  